<div class="container">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner loading" [style.display]="blockedUi ? 'block' : 'none'"></i>
  </div>
  }
  <div class="grid container-header">
    <div class="col-12 md:col-12 lg:col-6 title-position">
      <span class="title" id="titleDetails">{{ 'TRANSLATE.PRODUCT.DETAILS' | translate }}</span>
      <span class="title" id="titleEdit">{{ 'TRANSLATE.EDIT.PRODUCT' | translate }}</span>
      <span class="sub-title" id="subTitle">{{ 'TRANSLATE.REVIEW.UPDATE.PRODUCT.INFORMATION' | translate }}</span>
    </div>
  </div>

  <div class="container-body">

    <div class="product-itens">

      <div class="col-12 md:col-12 lg:col-6 element-edit space-first">
        <label class="element-edit-label" for="productName">{{ 'TRANSLATE.PRODUCT.NAME' | translate }} </label>
        <input class="element-edit-input disabled-input" id="productName" type="text" minlength="4"
          [(ngModel)]="product.name" minlength="4" maxlength="50" required pInputText>
        <div class="message-edit">
          @if (isProductNameEmpty()) {
          <p-message class="client-data-message" severity="error"
            text="{{ 'TRANSLATE.INFORM.NAME.PRODUCT' | translate }}">
          </p-message>
          } @else if (isProductNameTooShort()) {
          <p-message class="client-data-message" severity="error"
            text="{{ 'TRANSLATE.MIN.LENGTH.PRODUCT.NAME' | translate }}">
          </p-message>
          }
        </div>
      </div>

      <div class="col-12 md:col-3 lg:col-2 element-edit space-second">
        <label class="element-edit-label" for="productID">{{ 'TRANSLATE.ID.PRODUCT' | translate }} </label>
        <input class="element-edit-input disabled-input" id="productID" [(ngModel)]="product.id" type="text" disabled
          pInputText>
      </div>

      <div class="col-12 md:col-3 lg:col-2 element-edit space-second">
        <label class="element-add-edit-filter" for="productStatus">{{ 'TRANSLATE.STATUS' | translate }} </label>
        <p-dropdown [options]="listStatus" id="productStatus" [disabled]="selectDisabled"
          placeholder="{{ 'TRANSLATE.SELECT' | translate }}" (onChange)="statusChange($event)"
          [style]="{'minWidth':'100%'}" [(ngModel)]="selectedStatus">
          <ng-template pTemplate="item" let-item>
            {{item?.label | translate}}
          </ng-template>
          <ng-template pTemplate="selectedItem" let-item>
            {{item?.label | translate}}
          </ng-template>
        </p-dropdown>

        @if (isEditingMode && hasAttemptedSave && (inputProductStatus === null || inputProductStatus === undefined)) {
        <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.SELECT.STATUS' | translate }}">
        </p-message>
        }
      </div>

      <div class="col-12 md:col-3 lg:col-4 element-edit space-first">
        <label class="element-edit-label" for="productCountry">{{ 'TRANSLATE.COUNTRY' | translate }} </label>
        <input class="element-edit-input disabled-input" id="productCountry" [(ngModel)]="countryNameResult" type="text"
          maxlength="3" disabled pInputText>
      </div>

      <div class="col-12 md:col-3 lg:col-3 element-edit space-second">
        <label class="element-edit-label" for="productCode">{{ 'TRANSLATE.PRODUCT.SYMBOL' | translate }} </label>
        <input class="element-edit-input disabled-input" id="productCode" [(ngModel)]="product.code" type="text"
          minlenght="1" maxlength="10" disabled pInputText>

        @if (isEditingMode && hasAttemptedSave && (inputProductCode === null || inputProductCode === undefined)) {
        <p-message class="client-data-message" severity="error"
          text="{{ 'TRANSLATE.INFORM.PRODUCT.SYMBOL' | translate }}">
        </p-message>
        }
      </div>

      <div class="col-12 md:col-2 lg:col-3 element-edit space-second">
        <label class="element-edit-label" for="visit">{{ 'TRANSLATE.VISIT' | translate }} </label>
        <input class="element-edit-input disabled-input" id="visit" [(ngModel)]="product.visit" type="text"
          minlength="1" maxlength="2" min="1" max="99" (input)="visit($event)" disabled="true" pInputText>

        @if (isEditingMode && hasAttemptedSave && (inputProductVisit === null || inputProductVisit === undefined)) {
        <p-message class="client-data-message" severity="error"
          text="{{ 'TRANSLATE.INFORM.NUMBER.VISITS' | translate }}">
        </p-message>
        }
      </div>

      <div class="col-12 md:col-2 lg:col-2 element-edit space-second">
        <label class="element-edit-label" for="months">{{ 'TRANSLATE.MONTHS' | translate }}</label>
        <input class="element-edit-input disabled-input" id="months" [(ngModel)]="product.months" type="text"
          maxlength="3" (input)="monthsProduct($event)" disabled="true" pInputText>

        @if (isProductMonthsEmpty()) {
        <p-message class="client-data-message" severity="error"
          text="{{ 'TRANSLATE.INFORM.MONTHS' | translate }}">
        </p-message>
		} @else if (isProductMonthsZeroOrLess()) {
		<p-message class="client-data-message" severity="error"
		  text="{{ 'TRANSLATE.MUST.BE.GREATER.THAN.ZERO' | translate }}">
		</p-message>
        }
      </div>

      <div class="col-12 md:col-3 lg:col-3 element-edit space-second">
        <label class="element-edit-label" for="distance">{{ 'TRANSLATE.DISTANCE' | translate }}</label>
        <input class="element-edit-input disabled-input" id="distance" [(ngModel)]="inputProductDistanceDisplay" type="text"
          maxlength="7" (input)="distance($event)" disabled="true" pInputText>

        @if (isProductDistanceEmpty()) {
        <p-message class="client-data-message" severity="error"
          text="{{ 'TRANSLATE.INFORM.DISTANCE' | translate }}">
        </p-message>
		} @else if (isProductDistanceZeroOrLess()) {
		<p-message class="client-data-message" severity="error"
		  text="{{ 'TRANSLATE.MUST.BE.GREATER.THAN.ZERO' | translate }}">
		</p-message>
        }
      </div>

      <div class="col-12 md:col-12 lg:col-12 message-edit">

        <div class="col-12 md:col-12 lg:col-10 element-edit space-first">
          <label class="element-edit-label" for="productDescription">{{ 'TRANSLATE.DESCRIPTION' | translate }} </label>
          <textarea class="element-edit-input disabled-input" id="productDescription" [(ngModel)]="product.description"
            type="text" minlength="4" maxlength="300" pInputTextarea></textarea>

          <div class="char-counter">
            {{ product.description?.length || 0 }} {{ 'TRANSLATE.MAX.CHARACTERS.300' | translate }}
          </div>

          <div class="message-edit">
            @if (isProductDescriptionEmpty()) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.DESCRIPTION.PRODUCT' | translate }}">
            </p-message>
            } @else if (isProductDescriptionTooShort()) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.MIN.LENGTH.PRODUCT.DESCRIPTION' | translate }}">
            </p-message>
            }
          </div>
        </div>
      </div>

      <div class="col-12 md:col-3 lg:col-4 element-edit space-first">
        <label class="element-edit-label" for="account">{{ 'TRANSLATE.ACCOUNT.ENGLISH' | translate }}</label>
        <input class="element-edit-input disabled-input" id="account" [(ngModel)]="product.accountCode" type="text"
          maxlength="9" (keyup)="accountOnKeyUp($event)" pInputText>
      </div>

      <div class="col-12 md:col-3 lg:col-3 element-edit space-second">
        <label class="element-edit-label" for="actionCode">{{ 'TRANSLATE.ACTION.ENGLISH' | translate }}</label>
        <input class="element-edit-input disabled-input" id="actionCode" [(ngModel)]="product.actionCode" type="text"
          maxlength="1" (keyup)="actionCodeOnKeyUp($event)" pInputText>
      </div>

      <div class="col-12 md:col-3 lg:col-3 element-edit space-second">
        <label class="element-edit-label" for="coverageCode">{{ 'TRANSLATE.COVERAGE.ENGLISH' | translate }}</label>
        <input class="element-edit-input disabled-input" id="coverageCode" [(ngModel)]="product.coverageCode"
          type="text" maxlength="4" (keyup)="coverageCodeOnKeyUp($event)" pInputText>
      </div>

      <div class="col-12 md:col-3 lg:col-4 element-edit space-first">
        <label class="element-edit-label" for="insuranceCode">{{ 'TRANSLATE.INSURANCE.ENGLISH' | translate }}</label>
        <input class="element-edit-input disabled-input" id="insuranceCode" [(ngModel)]="product.insuranceCode"
          type="text" maxlength="4" (keyup)="insuranceCodeOnKeyUp($event)" pInputText>
        @if (isEditingMode && hasAttemptedSave && (inputProductInsuranceCode === null || inputProductInsuranceCode ===
        undefined)) {
        <p-message class="client-data-message" severity="error"
          text="{{ 'TRANSLATE.INFORM.INSURANCE.CODE' | translate }}">
        </p-message>
        }
      </div>

      <div class="col-12 md:col-6 lg:col-4 element-edit space-second">
        <label class="element-add-edit-filter" for="rateCurveEdit">{{ 'TRANSLATE.INVOICE.ENGLISH' | translate }}</label>
        <p-dropdown [options]="rateCurves" optionLabel="months" 
          optionValue="rateId" id="rateCurveEdit"
          [disabled]="selectDisabled" 
          [showClear]="true"
          [placeholder]="placeholderRateCurve | translate" 
          (onChange)="rateCurveOnChange($event)"
          [style]="{'minWidth':'100%'}" [(ngModel)]="selectedRateCurveId">
      
          <ng-template pTemplate="item" let-item>
            {{ item?.months }}
          </ng-template>
          <ng-template pTemplate="selectedItem" let-item>
            {{ item?.months }}
          </ng-template>
      
        </p-dropdown>
      
      </div>

      <div class="col-12 md:col-3 lg:col-3 element-edit space-second">
        <label class="element-edit-label" for="productCreationDate">{{ 'TRANSLATE.CREATION.DATE' | translate }}</label>
        <input class="element-edit-input disabled-input" id="productCreationDate"
          [(ngModel)]="productCreationDateformat" type="text" disabled="true" pInputText>
      </div>

      <div class="col-12 md:col-12 lg:col-12 message-edit">

        <div class="col-12 md:col-12 lg:col-10 element-edit space-first">
          <label class="element-edit-label" for="productDetails">{{ 'TRANSLATE.PRODUCT.DETAILS' | translate }}</label>
          <textarea class="element-edit-input disabled-input" id="productDetails" maxlength="1000"
            [(ngModel)]="product.details" type="text" pInputTextarea></textarea>

          <div class="char-counter">
            {{ product.details?.length || 0 }} {{ 'TRANSLATE.MAX.CHARACTERS.1000' | translate }}
          </div>
        </div>
      </div>

    </div>

    <div class="col-12 md:col-12 lg:col-12 button-position">

      @if (!isEditingMode) {
      <button id="btnReturn" class="undo-action-button app-clean-button" type="button" (click)="buttonReturn()">
        <i class="pi pi-arrow-left" aria-hidden="true"></i>
        <span class="undo-action-button-label">{{ 'TRANSLATE.RETURN' | translate }}</span>
      </button>
      }

      @if (!isEditingMode) {
      <button id="btnEdit" class="action-button app-filter-button" type="button" (click)="buttonEdit()">
        <i class="pi pi-pencil" aria-hidden="true"></i>
        <span class="action-button-label">{{ 'TRANSLATE.EDIT' | translate }}</span>
      </button>
      }

      @if (isEditingMode) {
      <button id="btnCancel" class="undo-action-button app-clean-button" type="button" (click)="buttonCancel()"
        [disabled]="blockedUi">
        <i class="pi pi-times" aria-hidden="true"></i>
        <span class="undo-action-button-label">{{ 'TRANSLATE.CANCEL' | translate }}</span>
      </button>
      }

      @if (isEditingMode) {
      <button id="btnSave" class="action-button app-filter-button" type="submit" (click)="buttonSave()"
        [disabled]="blockedUi">
        @if (!blockedUi) {
        <i class="pi pi-check" aria-hidden="true"></i>
        }
        @if (blockedUi) {
        <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
        }
        <span class="action-button-label">{{ (blockedUi ? 'TRANSLATE.SAVING' : 'TRANSLATE.SAVE') | translate }}</span>
      </button>
      }

    </div>

  </div>
</div>